module.exports = __webpack_public_path__ + "static/media/spartificiallogo.6b88f97d.jpg";